import React, { useState, useRef, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import Paper from "@material-ui/core/Paper";
import Container from "@material-ui/core/Container";
import theme from "../../layout/theme";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import Button from "@material-ui/core/Button";
import Swal from "sweetalert2";
import api from "../../../services/api";
import Typography from "@material-ui/core/Typography";
import Recaptcha from "react-recaptcha";
import { withRouter } from "react-router-dom";
import Grid from "@material-ui/core/Grid";
import consultaApi from "../../../services/consultaApi";

const tema = theme();

const useStyles = makeStyles((theme) => ({
  controlaLogin: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
    height: "100%",
    backgroundColor: "#F1F1F1",
  },
  controlaCard: {
    width: "80%",
    textAlign: "center",
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
  },
  controlaLogo: {
    width: tema.logoWidth,
  },
  formControl: {
    marginTop: theme.spacing(1),
  },
  button: {
    marginBottom: theme.spacing(1),
  },
  controlaCaptcha: {
    transform: "scale(0.7)",
    padding: 0,
  },
  ocultaCampo: {
    display: "none",
  },
  cadastreJa: {
    color: "#72bf44",
    paddingLeft: 6,
    "&:hover": {
      color: "#4b7d2d",
    },
  },
}));

function FormLogin(props) {
  //props
  const { history } = props;

  //Styles
  const classes = useStyles();

  //Usuario e senha
  const [usuario, setUsuario] = useState("");
  const [senha, setSenha] = useState("");

  //Conexoes e CNPJ
  const [conexoes, setConexoes] = useState([]);
  const [conid, setConid] = useState([]);

  //State se o CNPJ é único para alternar o ternário que desabilita o select
  const [unico, setUnico] = useState(true);

  //Usa a Label como referencia de tamanho para manter o tamanho da width
  const inputLabel = useRef(null);
  const [labelWidth, setLabelWidth] = useState(0);

  //Lógico valida se foi verificado o Captcha
  const [verificado, setVerificado] = useState(false);

  //States dos erros
  const [erroUsuario, setErroUsuario] = useState(false);
  const [erroUsuarioTexto, setErroUsuarioTexto] = useState();
  const [erroSenha, setErroSenha] = useState(false);
  const [erroSenhaTexto, setErroSenhaTexto] = useState();

  let camposErrados;

  //Seta a largura da label de acordo com o buscado nos states
  useEffect(() => {
    setLabelWidth(inputLabel.current.offsetWidth);
    //Limpa o armazenamento local
    localStorage.clear();
  }, []);
  // useEffect(() => {
  //     if (verificado && usuario && senha) {
  //         login()
  //     }
  // }, [verificado]);

  //Seta o CNPJ para o selecionado no select e reseta o captcha
  const handleChange = (event) => {
    setConid(event.target.value);
  };

  function vaiCadastroEmpresa() {
    history.push("/cadastro-empresa");
  }

  async function buscaConfiguracoes() {
    let procedure = {
      PROCNAME: "WEBSITE_BUSCA_CONF",
    };

    const resposta = await consultaApi(procedure);
    if (resposta.data.DATASET) {
      localStorage.setItem(
        "APRESENTA_PARCELA",
        resposta.data.DATASET[0].LAPRESENTAPARCELA
      );
      localStorage.setItem(
        "APRESENTA_VOLUME",
        resposta.data.DATASET[0].LAPRESENTAVOLUME
      );
      localStorage.setItem("CFOP_PADRAO", resposta.data.DATASET[0].CFOPPADRAO);
      localStorage.setItem(
        "DESCRICAO_CFOP_PADRAO",
        resposta.data.DATASET[0].CDSCFOP
      );
      localStorage.setItem(
        "UNIDADE_PADRAO",
        resposta.data.DATASET[0].UNIDADEPADRAO
      );
      localStorage.setItem(
        "DESCRICAO_UNIDADE_PADRAO",
        resposta.data.DATASET[0].CDSUNID
      );
      localStorage.setItem(
        "APRESENTA_TRANSPORTE",
        resposta.data.DATASET[0].LAPRESENTATRANSPORTE
      );
      localStorage.setItem(
        "APRESENTA_MENSAGEM",
        resposta.data.DATASET[0].LAPRESENTAMENSAGEM
      );
      localStorage.setItem(
        "GRUPO_IMPOSTO_PADRAO",
        resposta.data.DATASET[0].GRUPOIMPOSTOPADRAO
      );
      localStorage.setItem(
        "DESCRICAO_GRUPO_IMPOSTO_PADRAO",
        resposta.data.DATASET[0].CDSTAXGRUPO
      );
      localStorage.setItem(
        "PRIMEIRO_ACESSO",
        resposta.data.DATASET[0].PRIMEIROACESSO
      );
      localStorage.setItem(
        "APRESENTA_DESCRICAO_DETALHADA",
        resposta.data.DATASET[0].LAPRESENTACDETPMS
      );
    }
  }

  async function buscaDadosEmpresa() {
    let dadosEnvio = {
      DBSERVERNAME: localStorage.getItem("DBSERVERNAME"),
      DBUSERNAME: localStorage.getItem("DBUSERNAME"),
      DBESQUEMA: localStorage.getItem("DBESQUEMA"),
      DBPID: localStorage.getItem("DBPID"),
      MANDNUMBER: localStorage.getItem("MANDNUMBER"),
      PROCNAME: "WEBSITE_DADOS_EMPRESA",
      EMPNUMBER: localStorage.getItem("EMPNUMBER"),
    };

    const resposta = await api.post("/execute", dadosEnvio);
    if (resposta.data.DATASET) {
      localStorage.setItem(
        "CIDADE_EMPRESA",
        resposta.data.DATASET[0].CCDCIDADE
      );
    }
  }

  /**
   * Trecho Exclusivo para funcionamento do captcha
   * */

  //Declara a instancia para dar reset
  let recaptchaInstancia;

  //Faz o reset do Captcha
  const recaptchaReset = () => {
    recaptchaInstancia.reset();
    setVerificado(false);
  };

  //Faz o log confirmando se carregou o captcha
  function captchaCarregado() {
    // console.log("Captcha foi carregado com sucesso")
  }

  //Verifica o retorno do captcha e já seta o state para verificado caso tenha sido checado
  function verificaRetorno(response) {
    if (response) {
      setVerificado(true);
    }
  }
  /**
   * FIM
   * */

  async function login(e) {
    if (verificado && validaCampos()) {
      let dados = {
        LOGIN: usuario.toUpperCase(),
        SENHA: senha.toUpperCase(),
      };

      //Atribui o retorno da autenticação no servidor a uma variável
      const retorno = await api.post("/getconexaobyuser", dados);

      let data = retorno.data;

      if (data.CONEXOES) {
        setConexoes(data.CONEXOES);

        if (retorno.data.QTDE > 1) {
          setUnico(false);
          let validaCONID = conid;

          conexoes.forEach(async (conexao) => {
            if (conexao.CONID === validaCONID) {
              localStorage.setItem("CNPJ", conexao.CNPJ);
              localStorage.setItem("LOGIN", usuario);
              localStorage.setItem("CONNAME", conexao.CONNAME);
              localStorage.setItem("CONID", conexao.CONID);
              localStorage.setItem("DBSERVERNAME", conexao.DBSERVERNAME);
              localStorage.setItem("DBUSERNAME", conexao.DBUSERNAME);
              localStorage.setItem("DBESQUEMA", conexao.DBESQUEMA);
              localStorage.setItem("DBPID", conexao.DBPID);
              localStorage.setItem("MANDNUMBER", conexao.MANDNUMBER);
              localStorage.setItem("CNRSWCON", conexao.CNRSWCON);
              localStorage.setItem("CCDLOGIN", conexao.CCDLOGIN);

              let informacoes = {
                PROCNAME: "WEBSITE_GETINFO_LOGIN",
                CNPJ: localStorage.getItem("CNPJ"),
                LOGIN: localStorage.getItem("LOGIN"),
                CONNAME: localStorage.getItem("CONNAME"),
                DBSERVERNAME: localStorage.getItem("DBSERVERNAME"),
                DBUSERNAME: localStorage.getItem("DBUSERNAME"),
                DBESQUEMA: localStorage.getItem("DBESQUEMA"),
                DBPID: localStorage.getItem("DBPID"),
                MANDNUMBER: localStorage.getItem("MANDNUMBER"),
              };

              const retornoLogin = await api.post("/execute", informacoes);

              localStorage.setItem("EMPNUMBER", retornoLogin.data.EMPNUMBER);
              localStorage.setItem("USERNUMBER", retornoLogin.data.USERNUMBER);

              await buscaConfiguracoes();
              await buscaDadosEmpresa();
              history.push("/home");
            }
          });
        } else {
          if (conexoes !== []) {
            let conexaoUnica = data.CONEXOES[0];
            localStorage.setItem("CNPJ", conexaoUnica.CNPJ);
            localStorage.setItem("LOGIN", conexaoUnica.USUARIO);
            localStorage.setItem("CONNAME", conexaoUnica.CONNAME);
            localStorage.setItem("CONID", conexaoUnica.CONID);
            localStorage.setItem("DBSERVERNAME", conexaoUnica.DBSERVERNAME);
            localStorage.setItem("DBUSERNAME", conexaoUnica.DBUSERNAME);
            localStorage.setItem("DBESQUEMA", conexaoUnica.DBESQUEMA);
            localStorage.setItem("DBPID", conexaoUnica.DBPID);
            localStorage.setItem("MANDNUMBER", conexaoUnica.MANDNUMBER);
            localStorage.setItem("CNRSWCON", conexaoUnica.CNRSWCON);
            localStorage.setItem("CCDLOGIN", conexaoUnica.CCDLOGIN);

            let informacoes = {
              PROCNAME: "WEBSITE_GETINFO_LOGIN",
              CNPJ: localStorage.getItem("CNPJ"),
              LOGIN: localStorage.getItem("LOGIN"),
              CONNAME: localStorage.getItem("CONNAME"),
              DBSERVERNAME: localStorage.getItem("DBSERVERNAME"),
              DBUSERNAME: localStorage.getItem("DBUSERNAME"),
              DBESQUEMA: localStorage.getItem("DBESQUEMA"),
              DBPID: localStorage.getItem("DBPID"),
              MANDNUMBER: localStorage.getItem("MANDNUMBER"),
            };

            const retornoLogin = await api.post("/execute", informacoes);

            localStorage.setItem("EMPNUMBER", retornoLogin.data.EMPNUMBER);
            localStorage.setItem("USERNUMBER", retornoLogin.data.USERNUMBER);
            await buscaConfiguracoes();
            await buscaDadosEmpresa();
            if (localStorage.getItem("PRIMEIRO_ACESSO") === "1") {
              history.push("/primeiro-acesso");
            } else {
              history.push("/home");
            }
          }
        }
      } else {
        recaptchaReset();
        Swal.fire({
          type: "error",
          title: "Ooops!!!",
          html: ` <lu>
                                <li> ${data.MSGRET} </li>
                            </lu>`,
        });
      }
    } else {
      if (!verificado) {
        Swal.fire({
          type: "error",
          title: "Captcha",
          html: ` <lu>
                                <li> Captcha não Preenchido </li>
                            </lu>`,
        });
      } else {
        Swal.fire({
          type: "error",
          title: "Campos Inválidos",
          html:
            `<lu>` +
            camposErrados.map((campoErrado) => `<li>${campoErrado}</li>`) +
            `</lu>`,
        });
      }
    }
  }

  function validaCampos() {
    camposErrados = [];

    if (usuario === "" || usuario === null) {
      setErroUsuario(true);
      setErroUsuarioTexto("Por favor Preencha Usuário");
      camposErrados.push("Usuário");
    } else if (usuario.length < 3) {
      setErroUsuario(true);
      setErroUsuarioTexto("Usuário deve ter no mínimo 3 caracteres");
      camposErrados.push("Usuário");
    } else {
      setErroUsuario(false);
    }

    if (senha === "" || usuario === null) {
      setErroSenha(true);
      setErroSenhaTexto("Por favor preencha a Senha");
      camposErrados.push("Senha");
    } else if (senha < 7) {
      //colocar Lenght na senha
      setErroSenha(true);
      setErroSenhaTexto("Senha deve ter no mínimo 7 caracteres");
      camposErrados.push("Senha");
    } else {
      setErroSenha(false);
    }

    if (camposErrados.length === 0) {
      return true;
    } else {
      return false;
    }
  }

  return (
    <Container className={classes.controlaLogin}>
      <Paper className={classes.controlaCard}>
        <img
          src={tema.logo}
          alt="SimpleWork"
          className={classes.controlaLogo}
        />

        <form onSubmit={(e) => login(e)}>
          <Grid container align="center">
            <Grid item xs={12}>
              <TextField
                error={erroUsuario}
                helperText={erroUsuario ? erroUsuarioTexto : ""}
                fullWidth
                label="E-Mail"
                margin="normal"
                autoComplete="username"
                variant="outlined"
                value={usuario}
                onChange={(e) => setUsuario(e.target.value)}
                onBlur={recaptchaReset}
              />
            </Grid>

            <Grid item xs={12}>
              <TextField
                error={erroSenha}
                helperText={erroSenha ? erroSenhaTexto : ""}
                fullWidth
                label="Senha"
                type="password"
                autoComplete="current-password"
                margin="normal"
                variant="outlined"
                value={senha}
                onChange={(e) => setSenha(e.target.value)}
                // onBlur={recaptchaReset}
              />
            </Grid>

            <Grid item xs={12}>
              <FormControl
                variant="outlined"
                className={unico ? classes.ocultaCampo : classes.formControl}
                fullWidth
                disabled={unico ? true : false}
              >
                <InputLabel ref={inputLabel}>CNPJ</InputLabel>
                <Select
                  value={conid}
                  onChange={handleChange}
                  labelWidth={labelWidth}
                >
                  {conexoes.map((conexao) => (
                    <MenuItem value={conexao.CONID}>{conexao.CONID}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12} className={classes.controlaCaptcha}>
              <Recaptcha
                ref={(e) => (recaptchaInstancia = e)}
                sitekey="6Ledm7QUAAAAAMHoAXgwsBVSyaBcLWqgUZIVBu9S"
                render="explicit"
                onloadCallback={captchaCarregado}
                verifyCallback={verificaRetorno}
                expiredCallback={recaptchaReset}
                hl="pt-br"
              />
            </Grid>

            <Grid item xs={12}>
              <Button
                variant="contained"
                color="primary"
                fullWidth
                className={classes.button}
                disabled={!verificado}
                onClick={login}
              >
                Entrar
              </Button>
            </Grid>
          </Grid>
        </form>

        <Typography>
          Ainda não é cadastrado?
          <span onClick={vaiCadastroEmpresa} className={classes.cadastreJa}>
            Cadastre Já
          </span>
        </Typography>
      </Paper>
    </Container>
  );
}

export default withRouter(FormLogin);
